import { useNavigate } from "react-router-dom";
import { IconArrowLeft } from "@tabler/icons-react";
import ScrollProgressElement from "../components/ScrollProgressElement";
import CRP2324 from "../assets/resources/CRP23-24.pdf";
import CRP2627 from "../assets/resources/CRP26-27.pdf";


function ResourceHeaderSection({
  t,
  currentLanguage,
  isCarbonPage,
  removeBackButton,
  pdfYear
}) {
  const navigate = useNavigate();

  const navigateToResources = () => {
    navigate("/resources");
  };

  const handleBackToOverviewKeyPress = (event) => {
    if (event.key === "Enter") {
      navigateToResources();
    }
  };

  const pdfMap = {
    "2023-2024": CRP2324,
    "2026-2027": CRP2627,
  };

  const selectedPdf = pdfMap[pdfYear];

  return (
    <>
      <div className="resources-header-container">
        <div className="resources-wrapper">
          <h1 className="gray">{t.title}</h1>

          {isCarbonPage && selectedPdf && (
            <button className="cta-button">
              <a href={selectedPdf} target="_blank" rel="noopener noreferrer">
                {t.pdfButton}
              </a>
            </button>
          )}
        </div>
      </div>

      {!removeBackButton && (
        <div className="header" id="myHeader">
          <div
            className="back-container"
            onClick={navigateToResources}
            onKeyDown={handleBackToOverviewKeyPress}
            tabIndex="0"
          >
            <div className="back-wrapper">
              <span className="back-to-overview">
                <IconArrowLeft size={20} />{" "}
                {
                  {
                    en: "Back to overview",
                    fr: "Retour à l’aperçu",
                    de: "Zurück zur Übersicht",
                    es: "Volver al resumen",
                  }[currentLanguage]
                }
              </span>
            </div>
          </div>
          <ScrollProgressElement />
        </div>
      )}
    </>
  );
}

export default ResourceHeaderSection;
